// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://lejehpgyvxuetahdigje.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxlamVocGd5dnh1ZXRhaGRpZ2plIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk2NzA5NTAsImV4cCI6MjA3NTI0Njk1MH0.NuhK3jud8ZoWLQItY3L1unoDI-mI_ECVeVfE4QKTI4Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
